<template>
  <div
    style="padding-left: 24px; padding-right: 24px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 50px; border: 1px #C3C3C3 solid; justify-content: flex-start; align-items: center; gap: 5px; display: flex"
  >
    <span class="text-muted">{{ index + 1 }}</span>
    <div
      style="width: 16px; height: 16px; padding: 10px; border-radius: 34px; ; flex-direction: column; justify-content: center; align-items: center; gap: 10px; display: inline-flex"
      :style="{ background: model.color }"
    />
    <div
      style="color: #11291B; font-size: 16px; font-family: Lato; font-weight: 700; line-height: 21.60px; word-wrap: break-word"
    >
      {{ model.text }}
    </div>
    <div
      style="width: 16px; height: 16px; justify-content: center; align-items: center; display: flex"
    >
      <div class="pointer" @click="onDeleteHandler()">
        <i
          class="fal fa-times-circle"
          style="width: 16px; height: 16px; color: #C9545E"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chip',
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: () => 0,
    },
  },
  methods: {
    onDeleteHandler() {
      this.$emit('delete', this.model);
    },
  },
};
</script>

<style scoped lang="scss">
.text-gray {
  color: #727272;
}

.boder {
  border-right: 1px #b5c3bc solid;
}

.pointer {
  cursor: pointer;
}

.panel-content {
  padding: 24px;
  background: #f7f7f7;
  border-radius: 4px;
}

.text {
  margin-bottom: 5px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  letter-spacing: -0.005em;
  text-align: left;
}
</style>
